import React from 'react'
import { useModal } from '@hooks/useModal'
import { useUrlAuthErrorHandler, useEventAuthErrorHandler } from './AuthErrorHandler/hooks'

/**
 * Unified Auth Error Handler
 * Handles both event-based and URL-based authentication errors:
 * 1. Listens for 'authorizationError' custom events
 * 2. Watches URL for 'loginError' query parameter
 *
 * Both cases will open the sign-in modal with appropriate error messages
 */

export const AuthErrorHandler: React.FC<{ modalId?: string }> = ({ modalId }) => {
  const { openSignInModal, openRegisterModal } = useModal({})

  // Handle URL-based errors (from query parameters)
  useUrlAuthErrorHandler(modalId, openSignInModal, openRegisterModal)

  // Handle event-based errors (from custom events)
  useEventAuthErrorHandler(modalId, openSignInModal, openRegisterModal)

  return null
}

export default AuthErrorHandler
